import ImportLocations from './ImportLocations';

export default {
  ReactComponent: ImportLocations,
  bindings: {
    onLocationsImported: '<',
  },
};
